export default __webpack_public_path__ + "static/media/aiSpeechActive.9eac9996.svg";